module.exports = __webpack_public_path__ + "media/application/images/icons/weak-relationship-a7992d14cc0671e3dcc1b9831e15e0ed.svg";